import React, { useContext, MouseEventHandler, useCallback, PropsWithChildren } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import NavigationContextMenuItem, { ExternalNavigationContextMenuItemProps } from './NavigationContextMenuItem';
import NavigationContextMenuContext from './NavigationContextMenuContext';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';

type NavigationContextMenuButtonProps = PropsWithChildren<ExternalNavigationContextMenuItemProps> & {
    icon?: IconProp;
    onClick: MouseEventHandler<HTMLButtonElement>;
};

const NavigationContextMenuButton: React.FC<NavigationContextMenuButtonProps> = ({
    title,
    subtitle,
    icon,
    imageElement,
    children,
    disabled,
    onClick,
}) => {
    const itemProp: ExternalNavigationContextMenuItemProps = {
        title,
        subtitle,
        icon,
        imageElement,
    };

    const context = useContext(NavigationContextMenuContext);

    const handleClick: MouseEventHandler<any> = useCallback(
        (e) => {
            triggerHandler(onClick, e);
            context.toggle(false);
        },
        [context, onClick]
    );

    return (
        <NavigationContextMenuItem
            clickable
            disabled={disabled}
            {...itemProp}
            wrapper={
                <button type="button" disabled={disabled} onClick={handleClick} tabIndex={context.open ? undefined : -1} />
            }>
            {children}
        </NavigationContextMenuItem>
    );
};

export default NavigationContextMenuButton;
